module.exports = __webpack_public_path__ + "img/Group.2c0eda96.png";